function initHeaderAccountBlocks() {
  const accountLinks = document.querySelectorAll('[data-header-account]');
  if (!accountLinks.length) return;

  const isAccountRoute = window.location.pathname.indexOf('/account') === 0;
  accountLinks.forEach((link) => {
    if (!(link instanceof HTMLElement)) return;

    if (isAccountRoute) {
      link.setAttribute('aria-current', 'page');
    } else {
      link.removeAttribute('aria-current');
    }
  });
}

document.addEventListener('DOMContentLoaded', initHeaderAccountBlocks);
document.addEventListener('shopify:section:load', initHeaderAccountBlocks);
